<div *ngIf="constructionMode" class="construction-mode">
    <div class="construction-mode-title">We'll be back soon!</div>
    <div class="construction-mode-subtitle">
        Our servers are currently undergoing some planned maintenance, which
        should take only a few minutes to complete. Thank you for your patience!
    </div>

    <div class="construction-mode-community">
        In the meantime, checkout our
        <a href="https://discord.com/invite/ypDnFXN"
            >Discord community server</a
        >
    </div>
</div>

<div
    class="mac-electron-dragger"
    [ngClass]="{ 'mac-electron-dragger-short': editorIsOpen }"
    *ngIf="isMacElectronApp"></div>

<div *ngIf="!constructionMode" [className]="deviceSpecificClass">
    <div class="drag-and-drop-overlay" *ngIf="showDragAndDropUI"></div>

    <div *ngIf="isInitialized">
        <div id="error-message-band" *ngIf="errorMessage != ''">
            {{ errorMessage }}
            <img
                (click)="cancelError()"
                class="close-icon"
                src="../assets/img/close.svg" />
        </div>

        <div id="blink-container"></div>

        <app-navbar></app-navbar>

        <notifications></notifications>

        <app-modals *ngIf="isLoggedIn"></app-modals>

        <div
            id="app-body"
            [class.song-lyrics-panel-open]="
                isTracksListView && songLyricsPanelOpen
            "
            [style.--song-lyrics-panel-width]="songLyricsPanelWidth + 'px'"
            (dragover)="dragOverHandler($event)"
            (drop)="preventDropDefault($event)">
            <router-outlet></router-outlet>
        </div>

        <song-lyrics-panel
            *ngIf="isTracksListView && songLyricsPanelOpen"
            [song]="(playerService.query.currentSong$ | async)?.song || null"
            [width]="songLyricsPanelWidth"
            (widthChange)="setSongLyricsPanelWidth($event)"
            (close)="closeSongLyricsPanel()"></song-lyrics-panel>

        <div class="update-banner" *ngIf="isUpdating">
            <img src="assets/img/menu/changelog.svg" /> AIVA is being updated,
            some services might be interrupted for the next few minutes.
        </div>

        <app-player
            *ngIf="isLoggedIn"
            [showLyricsButton]="isTracksListView"
            [lyricsPanelOpen]="songLyricsPanelOpen"
            (lyricsPanelToggle)="toggleSongLyricsPanel()"></app-player>
    </div>

    <div class="aiva-loading-screen" *ngIf="!isInitialized">
        <div class="aiva-loading-screen-title">Loading your dashboard</div>
        <div class="w-48 mt-2 m-auto">
            <progressbar
                [progress]="loadingProgress"
                [total]="100"></progressbar>
        </div>
    </div>
</div>
